import React from "react";
import { useForm, useWatch } from "react-hook-form";
import { useWorkflowsBuilderPageView } from "../../pages/WorkflowsBuilderPage/WorkflowsBuilderPage.context";
import { useDrawerInvokers } from "@tiny/lib";
import { useConfigView } from "../../Config.context";
import { useAudienceData } from "../TriggerForm/SelectRules/AudienceSelector/AudienceSelector.hooks";

interface FormValues {
  segment_ids: Array<{ id: string; name: string }>;
}

const useAssignedToAudienceForm = ({ id }: { id: string }) => {
  const { updateNode, getNode, viewMode } = useWorkflowsBuilderPageView();
  const { hideDrawer } = useDrawerInvokers();
  const { config } = useConfigView();
  const node = getNode(id);
  console.log("node", node);

  const isTinyEmail = config?.appName === "tinyEmail";
  const isTinyAlbert = config?.appName === "tinyAlbert";

  const methods = useForm<FormValues>({
    defaultValues: {
      segment_ids: [],
    },
    mode: "onChange",
  });

  const { control, handleSubmit, setValue } = methods;
  const formValues = useWatch({ control });

  const audienceData = useAudienceData({
    node,
    isTinyEmail,
    isTinyAlbert,
    setValue: setValue as any,
    albertAudienceTypes: ["FORM", "UPLOAD"],
    formFieldName: "segment_ids",
  });

  const [saveDisabled, setSaveDisabled] = React.useState(true);

  React.useEffect(() => {
    const nodeAudienceIds =
      node?.data?.segment_ids?.map((aud: any) => aud.id) || [];
    const formAudienceIds = formValues.segment_ids?.map((aud) => aud.id) || [];

    const hasChanged =
      nodeAudienceIds.length !== formAudienceIds.length ||
      formAudienceIds.some((id) => !nodeAudienceIds.includes(id));

    const isValid = formAudienceIds.length > 0;

    setSaveDisabled(!hasChanged || !isValid);
  }, [node?.data?.segment_ids, formValues.segment_ids]);

  const onSubmit = handleSubmit((data) => {
    updateNode({
      id,
      data: {
        ...node?.data,
        segment_ids: data.segment_ids.map((aud) => aud.id),
        audienceName: data.segment_ids.map((aud) => aud.name).join(", "),
        config: {
          configured: true,
        },
      },
    });
    hideDrawer();
  });

  const handleCancel = () => {
    hideDrawer();
  };

  return {
    methods,
    control,
    formValues,
    onSubmit,
    handleCancel,
    saveDisabled,
    viewMode,
    isTinyEmail,
    ...audienceData,
  };
};

export default useAssignedToAudienceForm;
